$(document).ready(function () {
  var price = $('#customise-total-price').data('product-price');
  var total_price = $('#customise-total-price').data('total-price');
  const customProperty = $(".product-custom-property");
  $(".product-custom-property-edit-dlg-display-button").click(function (e) {
    e.preventDefault();
    $('.buyButton-with-price.no-js-hidden').html(total_price);
    customProperty.removeClass("close-state");
  });
  $(".product-custom-property .fold-custom-property-edit-dlg-btn").click(
    function (e) {
      e.preventDefault();
      $('.buyButton-with-price.no-js-hidden').html(price);

      if (customProperty) {
        customProperty.addClass("close-state");
      }
    }
  );
  $(".select__select.border-solid").focus(function () {
    $(this).addClass("focus");
  });
  $(".select__select.border-solid").blur(function () {
    $(this).removeClass("focus");
    $(this).attr('isClicked', false);
  });
  $(".select__select.border-solid").click(function () {
    if ($(this).hasClass('focus')) {
      if ($(this).attr('isClicked') == "true") {
        $(this).blur();
      } else {
        $(this).attr('isClicked', true);
      }
    }
  });

  const sleep = (ms) =>{
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    })
  };

  const setCapUpsellContainer = async (parent) => {
    await sleep(25);
    const capUpsellItemsContainer = parent.querySelector(".complementary-products__slideshow");
    const capUpsellItems = capUpsellItemsContainer.querySelectorAll('.complementary-slide');
    let totalHeight = 0;
    for (const [index, capUpsellItem] of capUpsellItems.entries()) {
      totalHeight += capUpsellItem.offsetHeight;
      if(index == 2) {
        break;
      }
    }
    totalHeight += parseInt(getComputedStyle(capUpsellItemsContainer).getPropertyValue('row-gap').replace("px","")) * 2;
    capUpsellItemsContainer.style.height = totalHeight + "px";
  }
  const targetNode = document.querySelector(".product__info-wrapper");
  const capUpsellContainer = document.querySelector(".complementary-products__slideshow");
  if(capUpsellContainer) {
    setCapUpsellContainer(targetNode);
  } else {
    if(targetNode) {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if(mutation.target.classList.contains('complementary-products')) {
            setCapUpsellContainer(mutation.target);
            observer.disconnect();
            break;
          }
        }
      })
      const config = {
        childList: true,
        subtree: true
      };
      observer.observe(targetNode, config);
    }
  }
  window.onresize = () => {
    if(capUpsellContainer) {
      setCapUpsellContainer(capUpsellContainer);
    } else if(targetNode) {
      setCapUpsellContainer(targetNode);
    }
  }
  
  var text__slider = new Swiper(".text__slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    autoplay: {
     delay: 3500,
     disableOnInteraction: false,
    },
    loop: false,
  });
  
});